import {
  Box,
  Stack
} from '@mui/material';
import {
  DailyReportDescriptionCard,
  DailyReportPhotoCard,
  ReportAccidentCard,
  ReportDeliveryCard,
  ReportInspectionCard,
  ReportSubcontractorCard
} from 'modules';
import * as ds from './dataService';

import React from 'react';
import { useParams } from 'react-router-dom';



export type DailyReportDetailSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: DailyReportDetailSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.dailyReportId ?? '');
  return (
    <Box>

      <DailyReportDescriptionCard.FC
        description={data.description}
        id={data.id}
      />
      <DailyReportPhotoCard.FC
        photos={data.photos}
        id={data.id}
      />
      <Stack
        paddingTop='1.5rem'
        direction='row'
        justifyContent='space-between'
        columnGap='1.5rem'
      >
        {/* LEFT */}
        <Stack
          flex='1 1 0'
          direction='column'
          rowGap='1.25rem'
        >
          <ReportInspectionCard.FC
            id={data.id}
            inspections={data.inspections}
          />
          <ReportDeliveryCard.FC
            id={data.id}
            deliveries={data.deliveries}
          />
        </Stack>

        {/* RIGHT */}
        <Stack
          flex='1 1 0'
          direction='column'
          rowGap='1.25rem'
        >
          <ReportAccidentCard.FC
            id={data.id}
            incidents={data.incidents}
          />
          <ReportSubcontractorCard.FC
            id={data.id}
            workLog={data.workLog}
          />
        </Stack>

      </Stack>
    </Box>

  );
};
